module.exports = __webpack_public_path__ + "static/img/carousel3.00ad4616.png";